import { Contract } from "../../../entity/Contract";
import { Method, ROUTES } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import { ContractDto } from "../../dto/Contract.Dto";
import { mapContractDtoToContract } from "../../mapper/ContractMapper";

export class WSHR {
  private static instance: WSHR;

  private constructor() {}

  public static getInstance(): WSHR {
    if (!WSHR.instance) {
      WSHR.instance = new WSHR();
    }
    return WSHR.instance;
  }

  public async getContractsByStoreId(storeId: string): Promise<Contract[]> {
    try {
      const url = ROUTES.HR + ROUTES.GET_CONTRACTS_BY_STORE + storeId;
      const response = await fetchAPI<ContractDto[]>({
        url: url,
        isAuthenticated: true,
        method: Method.GET,
      });
      return mapContractDtoToContract(response.data);
    } catch (error) {
      throw error;
    }
  }

  public async getContractsByUserId(userId: string): Promise<Contract> {
    try {
      const url = ROUTES.HR + ROUTES.GET_CONTRACTS_BY_USER + userId;
      const response = await fetchAPI<ContractDto[]>({
        url: url,
        isAuthenticated: true,
        method: Method.GET,
      });
      return mapContractDtoToContract(response.data)[0];
    } catch (error) {
      throw error;
    }
  }

  public async createContract(contract: Partial<Contract>): Promise<string> {
    try {
      const url = ROUTES.HR + ROUTES.CREATE_CONTRACT;
      const response = await fetchAPI<string>({
        url: url,
        isAuthenticated: true,
        method: Method.POST,
        params: contract,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async updateContract(
    contractId: string,
    storeId: string,
    userId: string,
    contract: Partial<Contract>,
  ): Promise<string> {
    try {
      const url = ROUTES.HR + ROUTES.UPDATE_CONTRACT;
      const response = await fetchAPI<string>({
        url: url,
        isAuthenticated: true,
        method: Method.PUT,
        params: { ...contract, id: contractId, storeId, userId },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default WSHR.getInstance();
